import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const CheckIcon = (props?: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path d="M6.53115 13.5069L1.96198 8.9377L0 10.8997L6.53115 17.4308L20 3.96198L18.038 2L6.53115 13.5069Z" />
  </SvgIcon>
);
